<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Importações SAAE</div>
              </div>
            </Breadcrumb>
          </div>
          <div class="eight wide right aligned column">
            <div class="actions">
              <router-link to="/saae-payments-imports/new">
                <i class="plus icon"></i>Nova Importação
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Carregando...</div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <table class="ui small striped table">
              <thead>
                <tr>
                  <th>Arquivo</th>
                  <th>Data</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.filename }}</td>
                  <td>{{ item.created_at | datetime }}</td>
                  <td class="right aligned">
                    <router-link :to="`/saae-payments-imports/${item.id}`">
                      <i class="list icon"></i>Ver Log
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!loading && items.length === 0">
                  <td colspan="3" class="center aligned">Nenhuma importação encontrada.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      items: []
    };
  },

  mounted() {
    this.search();
  },

  methods: {
    search() {
      this.loading = true;
      Api.saaePaymentsImports
        .search()
        .then(response => {
          this.items = response.data.payments_imports;
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
